import { render, staticRenderFns } from "./app-detail-download.vue?vue&type=template&id=4c6146a6&scoped=true&"
import script from "./app-detail-download.vue?vue&type=script&lang=js&"
export * from "./app-detail-download.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-download.vue?vue&type=style&index=0&id=4c6146a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6146a6",
  null
  
)

export default component.exports